/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  responseTime: 0,
  msgError: '',
};
export const attendanceTimeOffTrendsReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case actionType.ATTENDANCE_TIMEOFF_TRENDS + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.ATTENDANCE_TIMEOFF_TRENDS + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.ATTENDANCE_TIMEOFF_TRENDS + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.ATTENDANCE_TIMEOFF_TRENDS + '_ERROR':
      return {
        ...state,
        isLoading: false,
        isError: true,
        msgError: action.err,
        status: action.status
      }
    default:
      return state;
  }
};
